import React from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.css";

const Header = () => {
  return (
    <nav class="navbar navbar-expand-lg navbar-light bg-light mb-3  p-3">
      <div class="container-fluid bg-primary">
        <Link class="navbar-brand " to="/home">
          DrivingLab
        </Link>

        <div
          class="collapse navbar-collapse bg-primary ms-3"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <Link
                class="nav-link  bg-primary rounded p-2"
                aria-current="page"
                to="/home"
                activeStyle={{
                  fontWeight: "bold",
                  color: "red",
                }}
              >
                Home
              </Link>
            </li>
            <li class="nav-item">
              <Link
                class="nav-link"
                to="/service"
                activeStyle={{
                  fontWeight: "bold",
                  color: "red",
                }}
              >
                Service
              </Link>
            </li>

            <li class="nav-item">
              <Link
                class="nav-link "
                to="/about"
                activeStyle={{
                  fontWeight: "bold",
                  color: "red",
                }}
              >
                About Us
              </Link>
            </li>
            <li class="nav-item">
              <Link
                class="nav-link "
                to="contact"
                activeStyle={{
                  fontWeight: "bold",
                  color: "red",
                }}
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
